import { useCallback, useRef, useLayoutEffect, useEffect } from 'react'

// Define the callback type explicitly
type ShortcutCallback = (event: KeyboardEvent) => void;

export const useShortcut = (shortcut: string, callback: ShortcutCallback, options = { disableTextInputs: true }) => {
    const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback
  })

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {

    const target = event.target as HTMLElement;
    let isTextInput =
        target instanceof HTMLTextAreaElement ||
        target.closest('.MuiInputBase-root') || 
        (target instanceof HTMLInputElement &&
          (!target.type || target.type === 'text')) ||
        target.isContentEditable

      // Cancel shortcut if key is being held down or if any modifier key is pressed
      if (event.repeat || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) { 
        return;
      }

      // Don't enable shortcuts in inputs unless explicitly declared
      if (options.disableTextInputs && isTextInput) {
        // return event.stopPropagation()
        return;
      }

      // Single key shortcuts (e.g. pressing D)
      if (shortcut === event.key) {
        event.preventDefault();
        return callbackRef.current(event)
      }
    },
    // [keyCombo.length]
    [shortcut, options.disableTextInputs] 
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}